import { useAssetHelpers } from "@Client/@Composables/application-standalone/pages/assets/useAssetHelpers";
import { computed, defineComponent } from "@vue/composition-api";
import SummarySectionLayout from "./summary-section-layout.vue";
export default defineComponent({
  name: "AssetsSection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const {
      assetSummarySubtitle,
      applicantHasAssets,
      isAssetSectionVisibleForMainApplicant,
      isAssetSectionVisibleForCoApplicants
    } = useAssetHelpers();
    const sectionVisibilityValues = computed(() => ({
      mainApplicant: isAssetSectionVisibleForMainApplicant.value,
      coApplicants: isAssetSectionVisibleForCoApplicants.value
    }));
    return {
      assetSummarySubtitle,
      applicantHasAssets,
      sectionVisibilityValues
    };
  }
});